import * as React from 'react';
import { connect } from 'react-redux';
import {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion,
    fetchTiposAlicuotasIva,
} from '../../../../actions/publicacionesActions';
import { DropDownArrow, customStyle } from "../../../../template/CustomStyle";
import { currencyFormat } from '../../../../helper/publicacionHelper';
import { fetchRebate } from '../../../../actions/rebatesActions';
import Select from 'react-select';
import Rebate from './Rebate';

class PrecioPago extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rebate: this.props.rebate,
            alicuotaIva: null,
            alicuotaImpuestoInterno: this.props.publicacion?.alicuotaImpuestoInterno?.toString() || "0",
        };
        this.precioListaInputRef = React.createRef();
    }

    componentDidMount = () => {
        if (this.precioListaInputRef.current && !this.props.userType.isAdminMod) {
            this.precioListaInputRef.current.focus();
        }

        this.props.fetchTiposAlicuotasIva();
        this.setAlicuotaIvaFromProps();

        const publi = this.props.publicacion;
    };


    componentDidUpdate(prevProps) {
        if (prevProps.publicacion?.alicuotaIva !== this.props.publicacion?.alicuotaIva ||
            prevProps.alicuotasIva !== this.props.alicuotasIva) {
            this.setAlicuotaIvaFromProps();
        }
    }

    setAlicuotaIvaFromProps = () => {
        const { alicuotasIva, publicacion } = this.props;

        const encontrada = alicuotasIva?.find(
            (iva) => iva.alicuota.toString() === publicacion?.alicuotaIva?.toString()
        );

        this.setState({
            alicuotaIva: encontrada
                ? {
                    label: `${encontrada.alicuota}%`,
                    value: encontrada.alicuota.toString()
                }
                : null
        });
    };

    selectSearchHandler = (option, { name }) => {
        const publicacion = { ...this.props.publicacion };

        switch (name) {
            case "alicuotaIva":
                publicacion.alicuotaIva = option.label.replace('%', '');
                this.setState({ alicuotaIva: option });
                break;

            case "idTipoPublicacion":
                publicacion.idTipoPublicacion = option.value;
                publicacion.tipoPublicacion = this.props.tiposPublicacion.find(
                    tipo => tipo.codigo.toString() === option.value
                ) || {}; // fallback por si no encuentra
                break;

            default:
                publicacion[name] = option.value;
                break;
        }

        this.props.editPublicacion(publicacion);
    };

    handleInputChange = (event) => {
        if (!event) {
            console.error("Evento inválido en handleInputChange");
            return;
        }

        let publicacion = { ...this.props.publicacion };
        const { name, value } = event.target;
        let newValue = value;

        switch (name) {
            case "precioPromocional":
            case "precioLista":
                newValue = currencyFormat(value);
                break;

            case "alicuotaImpuestoInterno":
                const formattedValue = value.replace(",", ".");
                this.setState({ alicuotaImpuestoInterno: formattedValue });

                const parsedValue = parseFloat(formattedValue);
                if (!isNaN(parsedValue)) {
                    newValue = parsedValue;
                }
                break;

            default:
                publicacion[name] = value;
                break;
        }

        this.props.editPublicacion({
            ...this.props.publicacion,
            [name]: newValue,
        });
    };

    updateDataRebate = (id) => {
        this.props.fetchRebate(id);
        this.setState({ rebate: this.props.rebate });
    }

    onSelectSearchInputTipo = () => {
        if (!this.props.isEditing) {
            this.props.fetchTiposPublicacion(this.props.publicacion.idSeller);
        } else {
            this.props.fetchTiposPublicacion(this.props.publicacion.seller.codigo);
        }
    }

    onSelectSearchInputMarcas = () => {
        this.props.fetchTiposAlicuotasIva();
    }

    fetchComision = () => {
        const { publicacion } = this.props;

        return publicacion?.tipoPublicacion?.comision || 0;
    };

    fetchOpcionesIva = () => {
        const { alicuotasIva } = this.props;

        const opcionesIva = alicuotasIva.map((item) => (
            {
                label: `${item.alicuota}%`,
                value: item.id.toString(),
            }
        ));

        return opcionesIva;
    };

    fetchListaTipo = () => {
        const { tiposPublicacion } = this.props;

        if (!tiposPublicacion) return [];

        return tiposPublicacion.map((tipo) => ({
            label: tipo.descripcion,
            value: tipo.codigo.toString(),
        }));
    };

    fetchTipoVal = (listaTipo) => {
        const { publicacion } = this.props;

        // Si no existe, devuelve el de la publicación (mostrarlo aunque no esté en API)
        if (publicacion?.tipoPublicacion?.descripcion) {
            return {
                label: publicacion.tipoPublicacion.descripcion,
                value: publicacion.idTipoPublicacion?.toString() || "0",
            };
        }
    };

    render() {

        const comision = this.fetchComision();
        const opcionesIva = this.fetchOpcionesIva();

        const listaTipo = this.fetchListaTipo();
        const tipoVal = this.fetchTipoVal(listaTipo);

        const tipoPublicacion = this.props.publicacion.tipoPublicacion?.descripcion || "";

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">
                    <div className="col-12 col-md-6 form-group">
                        <label>Precio Lista</label>
                        <input
                            type="text"
                            className="form-control"
                            disabled={this.props.userType.isAdminMod}
                            value={this.props.publicacion.precioLista}
                            onChange={this.handleInputChange}
                            name="precioLista"
                            ref={this.precioListaInputRef}
                        />
                    </div>

                    <div className="col-12 col-md-6 form-group">
                        <label>Precio Oferta</label>
                        <input
                            type="text"
                            className="form-control"
                            disabled={this.props.userType.isAdminMod}
                            value={this.props.publicacion.precioPromocional}
                            onChange={this.handleInputChange}
                            name="precioPromocional"
                        />
                    </div>

                    <div className="col-12 col-md-6 form-group">
                        <label>Alícuota IVA</label>
                        <Select
                            name="alicuotaIva"
                            value={this.state.alicuotaIva}
                            options={opcionesIva}
                            onChange={(option) => this.selectSearchHandler(option, { name: "alicuotaIva" })}
                            styles={customStyle}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            onMenuOpen={this.onSelectSearchInputMarcas}
                            menuPortalTarget={document.body}
                        />
                    </div>

                    <div className="col-12 col-md-6 form-group">
                        <label>Alícuota Impuesto Interno</label>
                        <input
                            type="text"
                            className="form-control"
                            value={this.state.alicuotaImpuestoInterno}
                            name="alicuotaImpuestoInterno"
                            onChange={this.handleInputChange}
                        />

                    </div>

                    <div className="col-12 col-md-6 form-group">
                        <label>Tipo de publicacion</label>
                        {this.props.userType.isAdminMod ? (
                            <input
                                disabled
                                className="form-control"
                                value={tipoPublicacion}
                                name="idTipoPublicacion"
                            />
                        ) : (
                            <Select
                                name="idTipoPublicacion"
                                value={tipoVal}
                                options={listaTipo}
                                onChange={(option) => this.selectSearchHandler(option, { name: "idTipoPublicacion" })}
                                onInputChange={this.onSelectSearchInputTipo}
                                styles={customStyle}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                menuPortalTarget={document.body}
                            />
                        )}
                    </div>

                    <div className="col-12 col-md-6 form-group">
                        <label>Comisión</label>
                        <input
                            type="number"
                            disabled={this.props.userType.isAdminMod}
                            className="form-control"
                            value={this.props.userType.isAdminMod ? this.props.publicacion?.tipoPublicacion?.comision : comision}
                            name="comision"
                        />
                    </div>
                </div>

                <Rebate
                    publicacion={this.props.publicacion}
                    userType={this.props.userType}
                    rebate={this.props.rebate}
                    idUsuario={this.props.idUsuario}
                    updateDataRebate={this.updateDataRebate}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    publicacion: state.publicaciones.publicacion,
    tiposPublicacion: state.publicaciones.tiposPublicacion,
    userType: state.general.userType,
    idUsuario: state.general.userId,
    rebate: state.rebates.rebate,
    alicuotasIva: state.publicaciones.tiposAlicuotaIva,
});

export default connect(mapStateToProps, {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion,
    fetchRebate,
    fetchTiposAlicuotasIva,
})(PrecioPago);